// extracted by mini-css-extract-plugin
module.exports = {"button":"_2ZAq8X","container":"_7yju2D","slideUp":"_3Q2_jN","notification":"_1_PXVF","svg":"_26c_2S","text":"_2oEJZ2","shine-lines":"_3_hhdJ"};